import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f96d2f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "_page_wrap" }
const _hoisted_2 = {
  class: "_page_block_region",
  style: {"transition":"all 0.3s linear 0s","margin-left":"0px"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_block_title1 _priv_title" }, " 华美典型项目分布 ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "china_map",
  src: "https://huamei2001.oss-cn-shenzhen.aliyuncs.com/hm2001/cases/regions/projectmap.png",
  alt: ""
}, null, -1))
const _hoisted_5 = {
  class: "provinces",
  "data-v-397c8f52": ""
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "province-name",
  "data-v-397c8f52": ""
}, [
  /*#__PURE__*/_createTextVNode(" 广东 "),
  /*#__PURE__*/_createElementVNode("span", { class: "case_count" }, "59")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "province-img",
  src: "https://huamei2001.oss-cn-shenzhen.aliyuncs.com/hm2001/cases/regions/广东.png",
  alt: "",
  "data-v-397c8f52": ""
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "province-name",
  "data-v-397c8f52": ""
}, [
  /*#__PURE__*/_createTextVNode("浙江 "),
  /*#__PURE__*/_createElementVNode("span", { class: "case_count" }, "59")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "province-img",
  src: "https://huamei2001.oss-cn-shenzhen.aliyuncs.com/hm2001/cases/regions/浙江.png",
  alt: "",
  "data-v-397c8f52": ""
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "province-name",
  "data-v-397c8f52": ""
}, [
  /*#__PURE__*/_createTextVNode("江苏 "),
  /*#__PURE__*/_createElementVNode("span", { class: "case_count" }, "59")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "province-img",
  src: "https://huamei2001.oss-cn-shenzhen.aliyuncs.com/hm2001/cases/regions/江苏.png",
  alt: "",
  "data-v-397c8f52": ""
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "province-name",
  "data-v-397c8f52": ""
}, [
  /*#__PURE__*/_createTextVNode("四川 "),
  /*#__PURE__*/_createElementVNode("span", { class: "case_count" }, "59")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "province-img",
  src: "https://huamei2001.oss-cn-shenzhen.aliyuncs.com/hm2001/cases/regions/四川.png",
  alt: "",
  "data-v-397c8f52": ""
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "province-name",
  "data-v-397c8f52": ""
}, [
  /*#__PURE__*/_createTextVNode("河北 "),
  /*#__PURE__*/_createElementVNode("span", { class: "case_count" }, "59")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "province-img",
  src: "https://huamei2001.oss-cn-shenzhen.aliyuncs.com/hm2001/cases/regions/河北.png",
  alt: "",
  "data-v-397c8f52": ""
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "province-name",
  "data-v-397c8f52": ""
}, [
  /*#__PURE__*/_createTextVNode("山东 "),
  /*#__PURE__*/_createElementVNode("span", { class: "case_count" }, "59")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "province-img",
  src: "https://huamei2001.oss-cn-shenzhen.aliyuncs.com/hm2001/cases/regions/山东.png",
  alt: "",
  "data-v-397c8f52": ""
}, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "province-name",
  "data-v-397c8f52": ""
}, [
  /*#__PURE__*/_createTextVNode("贵州 "),
  /*#__PURE__*/_createElementVNode("span", { class: "case_count" }, "59")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "province-img",
  src: "https://huamei2001.oss-cn-shenzhen.aliyuncs.com/hm2001/cases/regions/贵州.png",
  alt: "",
  "data-v-397c8f52": ""
}, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "province-name",
  "data-v-397c8f52": ""
}, [
  /*#__PURE__*/_createTextVNode("福建 "),
  /*#__PURE__*/_createElementVNode("span", { class: "case_count" }, "59")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "province-img",
  src: "https://huamei2001.oss-cn-shenzhen.aliyuncs.com/hm2001/cases/regions/福建.png",
  alt: "",
  "data-v-397c8f52": ""
}, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "province-name",
  "data-v-397c8f52": ""
}, [
  /*#__PURE__*/_createTextVNode("陕西 "),
  /*#__PURE__*/_createElementVNode("span", { class: "case_count" }, "59")
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "province-img",
  src: "https://huamei2001.oss-cn-shenzhen.aliyuncs.com/hm2001/cases/regions/陕西.png",
  alt: "",
  "data-v-397c8f52": ""
}, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "province-name",
  "data-v-397c8f52": ""
}, [
  /*#__PURE__*/_createTextVNode("海南 "),
  /*#__PURE__*/_createElementVNode("span", { class: "case_count" }, "59")
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "province-img",
  src: "https://huamei2001.oss-cn-shenzhen.aliyuncs.com/hm2001/cases/regions/海南.png",
  alt: "",
  "data-v-397c8f52": ""
}, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "province-name",
  "data-v-397c8f52": ""
}, [
  /*#__PURE__*/_createTextVNode("湖北 "),
  /*#__PURE__*/_createElementVNode("span", { class: "case_count" }, "59")
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "province-img",
  src: "https://huamei2001.oss-cn-shenzhen.aliyuncs.com/hm2001/cases/regions/湖北.png",
  alt: "",
  "data-v-397c8f52": ""
}, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "province-name",
  "data-v-397c8f52": ""
}, [
  /*#__PURE__*/_createTextVNode("云南 "),
  /*#__PURE__*/_createElementVNode("span", { class: "case_count" }, "59")
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "province-img",
  src: "https://huamei2001.oss-cn-shenzhen.aliyuncs.com/hm2001/cases/regions/云南.png",
  alt: "",
  "data-v-397c8f52": ""
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_scroll_enter = _resolveComponent("scroll-enter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_scroll_enter, {
          _direction: "left",
          _delay: 300,
          class: "province",
          "data-v-397c8f52": ""
        }, {
          default: _withCtx(() => [
            _hoisted_6,
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_scroll_enter, {
          _direction: _ctx.windowWidth > 800 ? 'right' : 'left',
          _delay: 600,
          class: "province",
          "data-v-397c8f52": ""
        }, {
          default: _withCtx(() => [
            _hoisted_8,
            _hoisted_9
          ]),
          _: 1
        }, 8, ["_direction"]),
        _createVNode(_component_scroll_enter, {
          _direction: "left",
          _delay: 300,
          class: "province",
          "data-v-397c8f52": ""
        }, {
          default: _withCtx(() => [
            _hoisted_10,
            _hoisted_11
          ]),
          _: 1
        }),
        _createVNode(_component_scroll_enter, {
          _direction: _ctx.windowWidth > 800 ? 'right' : 'left',
          _delay: 600,
          class: "province",
          "data-v-397c8f52": ""
        }, {
          default: _withCtx(() => [
            _hoisted_12,
            _hoisted_13
          ]),
          _: 1
        }, 8, ["_direction"]),
        _createVNode(_component_scroll_enter, {
          _direction: "left",
          _delay: 300,
          class: "province",
          "data-v-397c8f52": ""
        }, {
          default: _withCtx(() => [
            _hoisted_14,
            _hoisted_15
          ]),
          _: 1
        }),
        _createVNode(_component_scroll_enter, {
          _direction: _ctx.windowWidth > 800 ? 'right' : 'left',
          _delay: 600,
          class: "province",
          "data-v-397c8f52": ""
        }, {
          default: _withCtx(() => [
            _hoisted_16,
            _hoisted_17
          ]),
          _: 1
        }, 8, ["_direction"]),
        _createVNode(_component_scroll_enter, {
          _direction: "left",
          _delay: 300,
          class: "province",
          "data-v-397c8f52": ""
        }, {
          default: _withCtx(() => [
            _hoisted_18,
            _hoisted_19
          ]),
          _: 1
        }),
        _createVNode(_component_scroll_enter, {
          _direction: _ctx.windowWidth > 800 ? 'right' : 'left',
          _delay: 600,
          class: "province",
          "data-v-397c8f52": ""
        }, {
          default: _withCtx(() => [
            _hoisted_20,
            _hoisted_21
          ]),
          _: 1
        }, 8, ["_direction"]),
        _createVNode(_component_scroll_enter, {
          _direction: "left",
          _delay: 300,
          class: "province",
          "data-v-397c8f52": ""
        }, {
          default: _withCtx(() => [
            _hoisted_22,
            _hoisted_23
          ]),
          _: 1
        }),
        _createVNode(_component_scroll_enter, {
          _direction: _ctx.windowWidth > 800 ? 'right' : 'left',
          _delay: 600,
          class: "province",
          "data-v-397c8f52": ""
        }, {
          default: _withCtx(() => [
            _hoisted_24,
            _hoisted_25
          ]),
          _: 1
        }, 8, ["_direction"]),
        _createVNode(_component_scroll_enter, {
          _direction: "left",
          _delay: 300,
          class: "province",
          "data-v-397c8f52": ""
        }, {
          default: _withCtx(() => [
            _hoisted_26,
            _hoisted_27
          ]),
          _: 1
        }),
        _createVNode(_component_scroll_enter, {
          _direction: _ctx.windowWidth > 800 ? 'right' : 'left',
          _delay: 600,
          class: "province",
          "data-v-397c8f52": ""
        }, {
          default: _withCtx(() => [
            _hoisted_28,
            _hoisted_29
          ]),
          _: 1
        }, 8, ["_direction"])
      ])
    ])
  ]))
}